export enum PaymentGatewayType {
    Prodamus = 'prodamus',
    YandexCheckout = 'yandexCheckout',
    RoboKassa = 'roboKassa',
    Stripe = 'stripe',
    PayPal = 'payPal',
    Cash = 'cash',
    CloudPayments = 'cloudPayments',
    WireTransfer = 'wireTransfer',
    NewStripe = 'newStripe',
    Midtrans = 'midtrans',
    TBank = 'tBank',
    Sberbank = 'sberbank',
    Fondy = 'fondy',
    SquareUp = 'squareUp',
    BePaid = 'bePaid',
    AuthorizeNet = 'authorizeNet',
    SmartGlocal = 'smartGlocal',
    BitPay = 'bitPay',
    EcPay = 'ecPay',
    TBankInstallment = 'tBankInstallment',
    Mercadopago = 'mercadopago',
    CyberSource = 'cyberSource',
    WayForPay = 'wayForPay',
    Mobbex = 'mobbex',
    ProntoPaga = 'prontoPaga',
    NMI = 'nmi',
    Cashfree = 'cashfree',
    Monobank = 'monobank',
    RoboKassaKz = 'roboKassaKz'
}
